const scopeTextsLaajuus = {
  1: 'Paikallinen',
  2: 'Alueellinen',
  4: 'Valtakunnallinen',
  8: 'Kansainvälinen'
};

const scopeTextsMaakunta = {
  11: 'Ahvenanmaa',
  12: 'Etelä-Karjala',
  13: 'Etelä-Pohjanmaa',
  14: 'Etelä-Savo',
  15: 'Kainuu',
  16: 'Kanta-Häme',
  17: 'Keski-Pohjanmaa',
  18: 'Keski-Suomi',
  19: 'Kymenlaakso',
  20: 'Lappi',
  21: 'Pirkanmaa',
  22: 'Pohjanmaa',
  23: 'Pohjois-Karjala',
  24: 'Pohjois-Pohjanmaa',
  25: 'Pohjois-Savo',
  26: 'Päijät-Häme',
  27: 'Satakunta',
  28: 'Uusimaa',
  29: 'Varsinais-Suomi'
};

/**
 * Returns finnish text for scope value.
 * @param {string} value
 * @return {string}
 */
function scope(value) {
  return scopeTextsLaajuus[value] || scopeTextsMaakunta[value];
}

export default scope;



// WEBPACK FOOTER //
// ./src/texts.js